import { useMemo } from "react";
import { useTableFetchContext } from "components/common/PaginatedEntityTable";
import useTableLayout from "components/common/EntityDataTable/hooks/useTableLayout";
const useNonDisplayedAttributes = (defaultLayout) => {
  const { attributes } = useTableFetchContext();
  const {
    layoutConfig: { attributes: columnPreferences = {} },
    isInitialLoading
  } = useTableLayout(defaultLayout);
  return useMemo(() => {
    if (isInitialLoading) return [];
    const displayedAttributesSet = new Set(
      Object.keys(columnPreferences).filter((key) => columnPreferences[key].status === "show")
    );
    return attributes.filter(({ id }) => !displayedAttributesSet.has(id));
  }, [attributes, columnPreferences, isInitialLoading]);
};
export default useNonDisplayedAttributes;
